/* ============================================================================
   PDP featured reviews — Aug:01, native. Progressive enhancement only.

   Differences from the A/B script, and why:
    · markup is server-rendered, so there is no DOM building, no injected
      <style>, no MutationObserver and no reparenting on resize
    · a real PAUSE control (WCAG 2.2.2). The A/B version paused on mouseenter
      only, so keyboard and touch users could never stop the rotation
    · honours prefers-reduced-motion: no auto-advance at all
    · if this file fails to load you still get a readable first review and
      working arrows are simply inert — nothing breaks
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    var cards = root.querySelectorAll('[data-fr-card]');
    if (cards.length < 2) return;

    var bar    = root.querySelector('[data-fr-bar]');
    var pause  = root.querySelector('[data-fr-pause]');
    var prev   = root.querySelector('[data-fr-prev]');
    var next   = root.querySelector('[data-fr-next]');
    var everyMs = parseInt(root.getAttribute('data-rotate-ms'), 10) || 6000;

    var i = 0, timer = null, paused = REDUCED;

    function paint() {
      if (bar) bar.style.width = (((i + 1) / cards.length) * 100) + '%';
    }
    function go(n) {
      var to = ((n % cards.length) + cards.length) % cards.length;
      if (to === i) { paint(); return; }
      cards[i].classList.remove('is-active');
      cards[i].setAttribute('aria-hidden', 'true');
      cards[to].classList.add('is-active');
      cards[to].removeAttribute('aria-hidden');
      i = to;
      paint();
    }
    function start() {
      stop();
      if (paused) return;
      timer = setInterval(function () { go(i + 1); }, everyMs);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function setPaused(p) {
      paused = p;
      if (pause) {
        pause.setAttribute('aria-pressed', String(p));
        pause.setAttribute('aria-label', p ? 'Play review rotation' : 'Pause review rotation');
      }
      if (p) stop(); else start();
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    if (pause) {
      pause.addEventListener('click', function () { setPaused(!paused); });
      if (REDUCED) setPaused(true);          /* reflect the real state in the UI */
    }

    /* hover pause is a convenience on top of the control, not a substitute */
    root.addEventListener('mouseenter', function () { if (!paused) stop(); });
    root.addEventListener('mouseleave', function () { if (!paused) start(); });

    /* swipe, mirroring the tested behaviour: 40px, horizontal only */
    var sx = 0, sy = 0, tracking = false;
    var wrap = root.querySelector('.pdp-fr__wrap');
    if (wrap) {
      wrap.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
      }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        go(i + (dx < 0 ? 1 : -1)); start();
      }, { passive: true });
      wrap.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }

    /* don't burn a rotation while the tab is in the background */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') stop();
      else if (!paused) start();
    });

    paint();
    start();
  }

  function boot() {
    document.querySelectorAll('[data-pdp-fr]').forEach(function (el) {
      if (el.__pdpFr) return;
      el.__pdpFr = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
